<template>
  <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
               fluid>
    <fin-maintenance-info :show-no-maintenance-info="true"/>
  </v-container>
</template>


<script>
import FinMaintenanceInfo from "@/components/common/Maintenance/MaintenanceInfo"

export default {
  name: "FinMaintenance",
  components: {
    FinMaintenanceInfo,
  }
}
</script>

<style lang="scss" scoped>

</style>
